import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addToCart } from "../../redux/cart/actions";
import { productDecrement } from "../../redux/product/actions";

export default function ProductItem({ product }) {
  const { id, productName, category, imgUrl, price, quantity, stock } = product;
  const dispatch = useDispatch();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleClick = () => {
    dispatch(addToCart(id, quantity, stock));
    dispatch(productDecrement(id));
  };
  useEffect(() => {
    if (quantity < 1) {
      // stock is out
      setIsButtonDisabled(true);
    }
  }, [quantity]);

  return (
    <div className="lws-productCard">
      <img className="lws-productImage" src={imgUrl} alt="product" />
      <div className="p-4 space-y-2">
        <h4 className="lws-productName">{productName}</h4>
        <p className="lws-productCategory">{category}</p>
        <div className="flex items-center justify-between pb-2">
          <p className="productPrice">
            BDT <span className="lws-price">{price}</span>
          </p>
          <p className="productQuantity">
            QTY <span className="lws-quantity">{quantity}</span>
          </p>
        </div>
        <button
          onClick={handleClick}
          disabled={isButtonDisabled}
          className="lws-btnAddToCart"
        >
          Add To Cart
        </button>
      </div>
    </div>
  );
}
